import {
  BrowserRouter,
  Route,
  Routes as ReactRouterRoutes,
} from 'react-router-dom';

import JobsV2App from 'hb-react/frontoffice/apps/JobsV2';
import { WithAppPageConfig } from 'hb-react/frontoffice/utils/WithAppPageConfig';
import GenericErrorBanner from 'hb-react/publicoffice/components/GenericErrorBanner';
import {
  ROUTE_TAG_FEATURES,
  ROUTE_TAG_APP_PAGES,
} from 'hb-react/publicoffice/constants/routeTags';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';
import { EvolutionTeamErrorBoundary } from 'hb-react/shared/components/ErrorBoundary';

// Constants to prevent re-creation on every render
const NETWORK_CONFIGURATION_OPTIONS = ['business_opportunities'];
const NETWORK_ROUTE_TAGS = [
  {
    routeTag: ROUTE_TAG_FEATURES,
    params: { app_names: ['opportunities'] },
  },
  {
    routeTag: ROUTE_TAG_APP_PAGES,
    params: { app_name: 'opportunities' },
  },
];

const JobsAppStandalone = (props) => {
  const { networkConfiguration, isError } = useNetworkConfiguration({
    networkConfigurationOptions: NETWORK_CONFIGURATION_OPTIONS,
    networkRouteTags: NETWORK_ROUTE_TAGS,
  });

  if (isError) {
    return <GenericErrorBanner />;
  }

  if (networkConfiguration) {
    const {
      colors,
      theming,
      styles,
      networkConfigData,
      featuresData,
      appPagesData,
    } = networkConfiguration;

    const {
      features: {
        opportunities: { extraData },
      },
    } = featuresData;
    const {
      avatar_thumb_url: avatarThumbUrl,
      title,
      user_fields_config: userFieldsConfig,
    } = extraData;

    const customNetwork = {
      app_pages: [appPagesData],
      network_configuration: networkConfigData,
      avatar_thumb_url: avatarThumbUrl,
      title,
      user_fields_config: userFieldsConfig,
      colors: colors?.colors,
      styles: styles?.styles,
      theming: theming?.theming,
    };

    return (
      <EvolutionTeamErrorBoundary app="po" module="jobs">
        <PublicOfficeApp network={customNetwork}>
          <WithAppPageConfig identifier="business_opportunities">
            {({ appPageConfig }) => (
              <BrowserRouter>
                <ReactRouterRoutes>
                  <Route
                    path="/opportunities/*"
                    element={
                      <JobsV2App configPage={appPageConfig} {...props} />
                    }
                  />
                </ReactRouterRoutes>
              </BrowserRouter>
            )}
          </WithAppPageConfig>
        </PublicOfficeApp>
      </EvolutionTeamErrorBoundary>
    );
  }

  return null;
};

export default JobsAppStandalone;
